<div class="info">
  <div class="icon">
    <ion-icon name="alberta-document-info"></ion-icon>
  </div>
  <div class="text-wrapper">
    <div class="title">{{ node.title }}</div>
    <div class="description bold" *ngIf="node.description">{{ node.description }}</div>
  </div>
</div>
